import React,{Component} from 'react';
import {Form,Input,Button} from 'antd'
import firebase from '../../config'
import {Box} from '@material-ui/core'

export default class Update extends Component{
    constructor(props){
        super(props);
        this.state={

            name:"hel",
            details:"",
            overview:"",
            report_days:NaN,
            price:NaN,
            
        }
    }
    componentDidMount(){
        var params= this.props.match.params
        firebase.firestore().collection('packages').doc(params.id).get().then(doc =>{
            this.setState(doc.data())
        })
    }

    handleSubmit =() => {
        console.log(this.state)
            var params= this.props.match.params

        firebase.firestore().collection('packages').doc(params.id).update(this.state).then(()=>{
            alert("updated")
        })
    }
    render(){
        var data = this.state
        return(
            <div>
                  <Box textAlign="center" fontFamily="monospace" fontWeight="bold" fontSize="1.1em"> Update Package</Box>

                <Form >
                    <Form.Item  label="name">
                        <Input value={data.name} name="name" onChange={(e)=>this.setState({"name":e.target.value})}/>
                    </Form.Item>
                    <Form.Item  label="Description">
                        <Input value={data.details} name="Description" onChange={(e)=>this.setState({"details":e.target.value})}/>
                    </Form.Item>
                    <Form.Item  label="Overview">
                        <Input value={data.overview} onChange={(e)=>this.setState({"overview":e.target.value})}/>
                    </Form.Item>
                    <Form.Item  label="price">
                        <Input value={data.price} name="price" onChange={(e)=>this.setState({"price":e.target.value})}/>
                    </Form.Item>
                    <Form.Item  label="report days">
                        <Input value={data.report_days}  onChange={(e)=>this.setState({"report_days":e.target.value})}/>
                    </Form.Item>
                    <Form.Item  label="name">
                        <Button onClick={this.handleSubmit} >Submit</Button>

                    </Form.Item>
                </Form>
            </div>
        )
    }
}